import { JsonDatePipe } from './json-date.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    JsonDatePipe,
  ],
  exports: [
    JsonDatePipe,
  ]
})
export class PipesModule { }
